import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Modal } from '../Modal'
import { Wallet } from './Wallet'
import { AbstractConnector } from '@web3-react/abstract-connector'
import { Colors, FontWeights, INTEGRAL_PRIVACY_URL, INTEGRAL_TERMS_URL } from '../../constants'
import { getSupportedWallets } from '../../utils'

interface Props {
  connect: (connector: AbstractConnector) => void
  onClose: () => void
}

export function ConnectModal({ connect, onClose }: Props) {
  const wallets = useMemo(() => getSupportedWallets(window), [])

  return (
    <Modal onClose={onClose} title="Connect to Wallet">
      <Terms>
        By connecting a wallet, you acknowledge you have read and agree to Integral's{' '}
        <a href={INTEGRAL_TERMS_URL} target="_blank">
          Terms of Use
        </a>{' '}
        and{' '}
        <a href={INTEGRAL_PRIVACY_URL} target="_blank">
          Privacy Policy
        </a>
        .
      </Terms>
      {wallets.map((wallet) => (
        <Wallet key={wallet.label} wallet={wallet} connect={connect} />
      ))}
    </Modal>
  )
}

const Terms = styled.div`
  padding: 14px 24px;
  font-size: 13px;
  colors: ${Colors.DarkerGray};
  background-color: ${Colors.LightestGray};

  a {
    color: ${Colors.Hover};
    font-weight: ${FontWeights.Bold};
  }
`
